module.exports = __webpack_public_path__ + "f572638f/img/placeholder.888fcd0b.svg";